import { render } from "./DeveloperView.vue?vue&type=template&id=7c204c2c"
import script from "./DeveloperView.vue?vue&type=script&lang=js"
export * from "./DeveloperView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__